<template>
    <div class="account">
        <div class="account-div">
            <div class="account-title">
                <img src="../assets/help-icon.png" alt="" />
                <span>帮助中心</span>
            </div>
            <div class="account-money">
                <div class="money-left">
                    <!-- <div class="left-title">
                        <div class="newTitle">{{ oneDetail.title }}</div>
                    </div> -->
                    <div :class="tabBox == item.id ? 'nleft-title' : 'left-title'" v-for="item in helpData"
                        :key="item.id" @click="tabDetail(item.id)">
                        <div class="newTitle">{{ item.title }}</div>
                    </div>
                </div>
                <div class="money-right">
                    <div class="right-title">{{ oneDetail.title }}</div>
                    <div class="right-box" v-html="contentHtml"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { helpListApi, helpDetailApi } from "../api/api.js";
export default {
    name: "HelpDetail",
    data() {
        return {
            oneDetail: {},
            contentHtml: ``,
            helpData: [],
            tabBox: '',
        };
    },
    components: {},
    mounted() {
        const detailData = JSON.parse(this.$route.query.detail)
        this.helpDetail(detailData.id)
        this.helpList(detailData)
    },
    methods: {
        async helpList(detailData) {
            const res = await helpListApi({
                pageindex: 1,
                pagesize: 6,
                cateType: 5,
            });
            this.helpData = res.data.data.records.filter(item => item.id !== detailData.id);

            this.helpData.splice(0, 0, detailData);

            this.tabBox = this.helpData[0].id
        },
        async helpDetail(id) {
            const res = await helpDetailApi(id);
            this.oneDetail = res.data.data;
            this.contentHtml = `<div style="padding:0 20px">${res.data.data.content}</div>`
            // this.helpList()
        },
        tabDetail(id) {
            this.tabBox = id
            this.helpDetail(id)
        }
    },
};
</script>
<style lang="scss" scoped>
.account {
    width: 100vw;
    height: 1403px;
    background: url("../assets/active-bg.png");
    background-position: center;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
}

.account-div {
    width: 70%;
    height: 1144px;

    .account-title {
        height: 5%;
        margin-bottom: 40px;
        display: flex;
        align-items: center;
        // padding-bottom: 20px;
        border-bottom: 1px solid #6d6d6d;

        img {
            width: 43px;
            padding-right: 10px;
        }

        span {
            font-size: 18px;
            color: #000;
            font-weight: bold;
        }
    }

    .account-money {
        width: 100%;
        height: 90%;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .money-left {
            width: 25%;
            height: 100%;
            cursor: pointer;

            .left-title {
                // height: 8%;
                font-size: 20px;
                font-weight: bold;
                color: #b1afaf;
                background: #8d8d8d;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .nleft-title {
                // height: 8%;
                font-size: 20px;
                font-weight: bold;
                color: #fff;
                background: #000;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .newTitle {
                width: 80%;
                text-align: center;
                border-bottom: 1px solid #5f5f5f;
                padding: 30px 0;
                white-space: nowrap;
                /* 不换行 */
                overflow: hidden;
                /* 隐藏超出的内容 */
                text-overflow: ellipsis;
                /* 用省略号表示被隐藏的部分 */
                max-width: 80%;
                /* 设置最大宽度以限制文本的显示长度 */
            }
        }

        .money-right {
            width: 73%;
            height: 100%;

            .right-title {
                height: 8%;
                font-size: 26px;
                font-weight: bold;
                background: #cccccc;
                display: flex;
                align-items: center;
                padding-left: 50px;
            }

            .right-box {
                width: 100%;
                height: 92%;
                overflow: auto;
                background: rgb(234, 234, 234, 0.7);

            }
        }
    }
}

::v-deep .right-box img {
    display: block;
    margin: 0 auto;
    width: 60%;
}
</style>
